<template>
  <div class="container">

    <div class="mt-5 row">
      <div class="col-12 col-md">
        <p class="lead">La Banque de Matériel est un service destiné aux associations genevoises qui désirent louer du matériel à bas coûts. Il est proposé conjointement par la <a href="https://www.mia-ge.ch/">MIA</a> et <a href="https://lyoxa.ch/">Lyoxa</a>, avec le généreux soutien des communes d’Avusy, Dardagny, Genthod, Perly-Certoux et Thônex.</p>
      </div>
      <div class="col-md-3">
        <a href="https://www.mia-ge.ch/"><img src="/img/logo-mia.png" class="img-fluid" alt="MIA" style="max-width: 200px;"></a>
      </div>
    </div>

    <section class="mt-5">
      <h1>Liste du matériel disponible</h1>
      <table class="table table-striped mt-3">
        <thead class="thead-dark">
          <tr>
            <th scope="col">Quoi?</th>
            <th scope="col">Prix de location<br>(pour 1 semaine)</th>
            <th scope="col">Nombre</th>
            <th scope="col">Image</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="materiel in materiels" :key="materiel.name">
            <th scope="row">{{ materiel.name }}</th>
            <td>{{ materiel.price }}</td>
            <td>{{ materiel.stock }}</td>
            <td>
              <a :href="materiel.image" v-if="materiel.image">Image</a>
            </td>
          </tr>
        </tbody>
      </table>
    </section>

    <hr class="my-5">

    <section class="mt-5">
      <h1>Réservation</h1>
      <form-reservation />
    </section>
  </div>
</template>

<script>
import FormReservation from '@/components/form/Reservation'

export default {
  name: 'home',
  components: {
    FormReservation
  },
  data () {
    return {
      materiels: [
        {
          id: '',
          name: 'Tente 3x3m "parapluie"',
          price: 'CHF20.00/unité',
          stock: 3,
          image: '/img/materiel/1_Tente.jpg'
        },
        {
          id: '',
          name: 'Tente 3x3m à monter',
          price: 'CHF10.00/unité',
          stock: 2
        },
        {
          id: '',
          name: 'Talkie-walkies',
          price: 'CHF15.00/paire ou CHF 20.00/quatre',
          stock: 4,
          image: '/img/materiel/2_Talkie_walkie_boite.jpg'
        },
        {
          id: '',
          name: 'Plaques de cuisson',
          price: 'CHF5.00/unité',
          stock: 1,
          image: '/img/materiel/3_Plaque_cuisson.jpg'
        },
        {
          id: '',
          name: 'Machine à hot-dog',
          price: 'CHF5.00/unité',
          stock: 1,
          image: '/img/materiel/4_Machine_hotdog.jpg'
        },
        {
          id: '',
          name: 'Extincteur',
          price: 'CHF5.00/unité',
          stock: 1,
          image: '/img/materiel/5_Extincteur.jpg'
        },
        {
          id: '',
          name: 'Beamer',
          price: 'CHF20.00/unité',
          stock: 1
        },
        {
          id: '',
          name: 'Verres en plastique rigide réutilisables',
          price: 'CHF0.18/unité',
          stock: 560,
          image: '/img/materiel/6_Verres.jpg'
        },
        {
          id: '',
          name: 'Cintres',
          price: 'CHF1.00/lot de 10',
          stock: 445,
          image: '/img/materiel/7_Cintres_2.jpg'
        },
        {
          id: '',
          name: 'Caisses',
          price: 'CHF5.00/unité',
          stock: 5,
          image: '/img/materiel/8_Caisse_monnayeur.jpg'
        },
        {
          id: '',
          name: 'Chariot',
          price: 'CHF5.00/unité',
          stock: 1
        },
        {
          id: '',
          name: 'Diable',
          price: 'CHF5.00/unité',
          stock: 1
        },
        {
          id: '',
          name: 'Caisse à outils',
          price: 'CHF10.00/unité',
          stock: 1
        },
        {
          id: '',
          name: 'Séparateurs de vente',
          price: 'CHF2.00/unité',
          stock: 4
        },
        {
          id: '',
          name: 'Sonomètre',
          price: 'CHF10.00/unité',
          stock: 1,
          image: '/img/materiel/9_Sonomètre2.jpg'
        },
        {
          id: '',
          name: 'Portants de vestiaire',
          price: 'CHF3.00/unité',
          stock: 12
        },
        {
          id: '',
          name: 'Tables de beer-pong',
          price: 'CHF10.00/unité',
          stock: 4
        },
        {
          id: '',
          name: 'Tables de manifestation',
          price: 'CH5.00/unité',
          stock: 5
        },
        {
          id: '',
          name: 'Trousse de premiers soins',
          price: 'CH5.00/unité',
          stock: 1,
          image: '/img/materiel/10_Trousse_secours.jpg'
        }
      ]
    }
  }
}
</script>
